import { RecentlyViewed } from '@theme/recently-viewed-products';

class VivaRecentlyViewed extends HTMLElement {
  connectedCallback() {
    this.load();
  }

  async load() {
    const currentProductId = this.dataset.currentProductId;
    const productIds = RecentlyViewed.getProducts().filter((id) => id !== currentProductId).slice(0, 4);
    if (productIds.length === 0) return;

    const url = new URL(this.dataset.searchUrl, window.location.origin);
    url.searchParams.set('q', productIds.map((id) => `id:${id}`).join(' OR '));
    url.searchParams.set('resources[type]', 'product');
    url.searchParams.set('section_id', this.dataset.sectionId);

    try {
      const response = await fetch(url.toString(), { headers: { Accept: 'text/html' } });
      if (!response.ok) return;

      const documentFragment = new DOMParser().parseFromString(await response.text(), 'text/html');
      const source = documentFragment.querySelector('#predictive-search-products ul');
      const target = this.querySelector('[data-recently-viewed-grid]');
      if (!source || !target) return;

      const cards = [...source.children].filter((item) => item.querySelector('.resource-card'));
      if (cards.length === 0) return;

      cards.slice(0, 4).forEach((card) => target.append(card));
      this.hidden = false;
    } catch (error) {
      // The section stays hidden when the recommendation request is unavailable.
    }
  }
}

if (!customElements.get('viva-recently-viewed')) {
  customElements.define('viva-recently-viewed', VivaRecentlyViewed);
}
